/* eslint-disable no-use-before-define */
import React, { useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  option: {
    fontSize: 15,
    "& > span": {
      marginRight: 10,
      fontSize: 18,
    },
  },
});

export default function AutoSelect(props) {
  const { options, filters, setFilters, id, multipleFlag, setSearchText, onInputChange } = props;
  const classes = useStyles();

  useEffect(() => {
    console.log("filters",filters);
  }, [filters]);

  // Find the selected option object from the string value stored in filters
  const selectedValue = filters[id] 
    ? options.find(option => option.name === filters[id]) || null
    : null;

  return (
    <Autocomplete
      multiple={multipleFlag === false ? false : true}
      id={id}
      value={selectedValue}
      onChange={(event, value) => {
        setFilters({ ...filters, [id]: value ? value.name : "" });
      }}
      onInputChange={onInputChange}
      style={{ width: 250 }}
      options={options}
      classes={{
        option: classes.option,
      }}
      //   autoHighlight
      getOptionLabel={(option) => option.name || ""}
      renderOption={(option) => <React.Fragment>{option.name}</React.Fragment>}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          size="small"
          placeholder="Select & Type"
          inputProps={{
            ...params.inputProps,
            // autoComplete: 'new-password', // disable autocomplete and autofill
          }}
        />
      )}
    />
  );
}
